import { useEffect, useState } from 'react'

import {
  handlers,
} from '@kaidam/fc-shared/src/frontend/store/utils/api'

import {
  IData_Org_With_Profile,
} from '@kaidam/fc-shared/src/types/rbac'

const useOrgs = () => {
  const [ orgs, setOrgs ] = useState<IData_Org_With_Profile[]>([])

  useEffect(() => {
    const doAsync = async () => {
      const data = await handlers.get<IData_Org_With_Profile[]>(`/ft_booking_public/orgs`)
      setOrgs(data)
    }
    doAsync()
  }, [])

  return orgs
}

export default useOrgs